import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/login",
  },
  {
    path: "/login",
    component: () => import("@/views/auth/login"),
    meta: {
      isNotAuth: true,
    },
  },
  {
    path: "/rest-password",
    component: () => import("@/views/auth/Restpassword"),
    meta: {
      isNotAuth: true,
    },
  },
  {
    path: "/set-password/:key",
    component: () => import("@/views/auth/setPassword"),
    meta: {
      isNotAuth: true,
    },
  },
  {
    path: "/app",
    component: () => import("@/views/Index.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "help",
        component: () => import("@/views/pages/help/index.vue"),
      },
      {
        path: "analysis",
        component: () => import("@/views/pages/analysis/index.vue"),
      },
      {
        path: "packages",
        component: () => import("@/views/pages/packages/index.vue"),
      },
      {
        path: "packages/new",
        component: () => import("@/views/pages/packages/new/index.vue"),
      },
      // {
      //   path: "products",
      //   component: () => import("@/views/pages/products/index.vue"),
      // },
      {
        path: "instructions",
        component: () => import("@/views/pages/instructions/index.vue"),
      },
      {
        path: "about",
        component: () => import("@/views/pages/about/index.vue"),
      },
      {
        path: "settings",
        component: () => import("@/views/pages/settings/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "meta/settings",
        component: () => import("@/views/pages/settings/metaSettings.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "track",
        component: () => import("@/views/pages/track/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "plan",
        component: () => import("@/views/pages/plan/index.vue"),
        meta: {
          requiresAuth: true,
        },
      }, {
        path: "trust",
        component: () => import("@/views/pages/trust/index.vue"),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "developer",
        component: () => import("@/views/pages/app/index.vue"),
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "employees",
        component: () => import("@/views/pages/employees/index.vue"),
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "vehicle",
        component: () => import("@/views/pages/vehicle/index.vue"),
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "employees/new",
        component: () => import("@/views/pages/employees/new/index.vue"),
        // meta: {
        //   requiresAuth: true,
        // },
      },
      {
        path: "employees/update/:id",
        component: () => import("@/views/pages/employees/update/index.vue"),
      },
      {
        path: "place",
        component: () => import("@/views/pages/geo_place/index.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
